import React from "react";
import {IGridConfigItem} from "../../../../constants/interfaces";

type Props = {
	item: IGridConfigItem,
	updateConfig: Function
}

const HomePage = (props: Props) => {
	return (
		<div className="config-item__show-circles mb-2 mt-2">
			<label className="control control-checkbox"
				   htmlFor={`checkbox-homepage-${props.item.cell_id}`}>
				<input type="checkbox"
					   id={`checkbox-homepage-${props.item.cell_id}`}
					   onChange={() => props.updateConfig(['not_on_homepage'], [props.item.not_on_homepage === 1 ? 0 : 1])}
					   value="not_on_homepage"
					   checked={!!props.item.not_on_homepage}
				/>
				<div className="control-indicator"></div>
				Not on homepage
			</label>
		</div>
	);
};

export default HomePage;
